import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Modal } from '../../components';
import { FormInput } from '../../components/form';
import { FormCheckbox } from '../../components/form';

interface ICancelSellerOrderModalProps  {
  onSubmit: (_values: ICancelSellerOrderValues) => void;
  onClose: () => void;
  loading: boolean;
  open: boolean;
}

export interface ICancelSellerOrderValues {
  reason: string;
  refund: boolean;
  restock: boolean;
  email: boolean;
}

const CancelSellerOrderValidationSchema = yup.object({
  reason: yup.string().required('Please enter a reason for canceling the order'),
});

export const CancelSellerOrderModal: React.FC<ICancelSellerOrderModalProps> = ({
  onSubmit,
  onClose,
  open,
  loading
}) => {
  return (
    <Formik<ICancelSellerOrderValues>
      initialValues={{
        reason: '',
        refund: false,
        restock: false,
        email: false,
      }}
      validationSchema={CancelSellerOrderValidationSchema}
      onSubmit={(values, { resetForm }) => {
        onSubmit(values);
        resetForm();
      }}
    >
      {({ handleSubmit }) => (
        <Modal
            open={open}
                  primaryAction={{
                      label: 'Cancel Order',
                      variant: 'destructive',
                      disabled: loading,
                      loading: loading,
                      onClick: () => handleSubmit(),
                  }} title={'Cancel'} onClose={onClose}        >
            <FormInput
              type="text"
              label="Reason"
              name="reason"
              autoComplete="off"
              disabled={loading}
            />
            <FormCheckbox
              label="Refund"
              name="refund"
              disabled={loading}
            />
            <FormCheckbox
              label="Restock"
              name="restock"
              disabled={loading}
            />
            <FormCheckbox
              label="Email"
              name="email"
              disabled={loading}
            />
        </Modal>
      )}
    </Formik>
  );
};
